import { baseUrl } from '@/shared/constants'
import axios from 'axios'

export const getSteamAuthUrl = async (token: string) => {
  const response = await axios.get(`${baseUrl}/steam/connect`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data
}

export const getSteamRefreshData = async (token: string) => {
  const response = await axios.get(`${baseUrl}/steam/refresh`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
export const getEpicRefresh = async (token: string) => {
  const response = await axios.get(`${baseUrl}/epic/refresh`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getRecommendations = async (token: string) => {
  const response = await axios.get(`${baseUrl}/steam/favorites`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}


